import { render } from "./SendSmartContractAddPhaseModal.vue?vue&type=template&id=6a899c88&ts=true"
import script from "./SendSmartContractAddPhaseModal.vue?vue&type=script&lang=ts"
export * from "./SendSmartContractAddPhaseModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__